import axios from "axios";
import { authCheckError, authCheckSuccess, AuthInfo, initiateCheckAuth, InitiateCheckAuth } from "./auth";
import { apiBaseUrl } from "./rootSaga";
import { put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";

function* executeAuthCheck(authInfo: PayloadAction<AuthInfo>): any {
    try {
        yield axios.post(`${apiBaseUrl}/api/TerminalCheckouts/checkLogin`, 
            {},
            {
                auth: {
                    username: authInfo.payload.username,
                    password: authInfo.payload.password
                }
            });
        yield put(authCheckSuccess());
    } catch (error: any) {
        yield put(authCheckError(`${error.toString()}`))
    }
}

export function* watchInitiateAuthCheck() {
    yield takeLatest(InitiateCheckAuth, executeAuthCheck);
}